import { render, staticRenderFns } from "./STab.vue?vue&type=template&id=05e2cd7d&scoped=true&"
import script from "./STab.vue?vue&type=script&lang=js&"
export * from "./STab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2cd7d",
  null
  
)

export default component.exports